import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { combineClasses } from '../../utils/styling';

const NotFound = () => {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className={combineClasses([classes.NotFound, classes.Container])}>
      <h1>
        {t('notFoundPage.invalidAddress', { address: `${location.pathname}` })}
      </h1>
      <h1>{t('notFoundPage.contactSupport')} support@nordkap.se</h1>
    </div>
  );
};

export default NotFound;
